import { useDispatch, useSelector } from "react-redux";
import { Badge, Box, IconButton, Typography } from "@mui/material";
import {
  PersonOutline,
  ShoppingBagOutlined,
  MenuOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { shades } from "../../theme";
import { setIsCartOpen } from "../../state";
import useMediaQuery from "@mui/material/useMediaQuery";

function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.cart);
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      width="100%"
      backgroundColor="rgba(255, 255, 255, 0.95)"
      color="black"
      position="fixed"
      top="0"
      left="0"
      zIndex={2000}
      boxShadow="0 2px 12px rgba(0,0,0,0.06)"
      sx={{ height: isMobile ? "auto" : "60px" }}
    >
      <Box
        width={isMobile ? "100%" : "90%"}
        margin="auto"
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        justifyContent={isMobile ? "center" : "space-between"}
        alignItems={isMobile ? "flex-start" : "center"}
        py={isMobile ? 1.2 : 1.5}
      >
        <Box
          width={isMobile ? "100%" : "auto"}
          display="flex"
          justifyContent={isMobile ? "center" : "flex-start"}
          alignItems="center"
          sx={{ mb: isMobile ? 0.5 : 0 }}
        >
          <Typography
            onClick={() => navigate("/")}
            sx={{
              "&:hover": { cursor: "pointer" },
              fontFamily:
                "MSCHFSansMono, monospace, Arial, Helvetica, sans-serif",
              fontWeight: 900,
              fontSize: "22px",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              textShadow: "0 1px 2px rgba(0,0,0,0.1)",
              WebkitTextStroke: "0.5px rgba(0,0,0,0.1)",
            }}
            color={shades.secondary[500]}
          >
            SHOP APP
          </Typography>
        </Box>
        <Box
          width={isMobile ? "100%" : "auto"}
          display="flex"
          justifyContent={isMobile ? "center" : "flex-end"}
          alignItems="center"
          columnGap="15px"
          zIndex="2"
          sx={{ mt: isMobile ? 0.5 : 0 }}
        >
          <IconButton
            sx={{
              color: shades.neutral[700],
              transition: "all 0.3s ease",
              "&:hover": {
                color: shades.secondary[500],
                transform: "scale(1.1)",
                backgroundColor: "rgba(214, 0, 28, 0.1)",
              },
              "& .MuiSvgIcon-root": {
                fontSize: "24px",
              },
            }}
          >
            <SearchOutlined />
          </IconButton>
          <IconButton
            sx={{
              color: shades.neutral[700],
              transition: "all 0.3s ease",
              "&:hover": {
                color: shades.secondary[500],
                transform: "scale(1.1)",
                backgroundColor: "rgba(214, 0, 28, 0.1)",
              },
              "& .MuiSvgIcon-root": {
                fontSize: "24px",
              },
            }}
          >
            <PersonOutline />
          </IconButton>
          <Badge
            badgeContent={cart.length > 99 ? "99+" : cart.length}
            color="secondary"
            invisible={cart.length === 0}
            sx={{
              "& .MuiBadge-badge": {
                right: 0,
                top: 0,
                width: 16,
                height: 16,
                minWidth: 16,
                minHeight: 16,
                borderRadius: "50%",
                fontSize: "0.75rem",
                fontWeight: 700,
                fontFamily: "inherit",
                backgroundColor: shades.secondary[500],
                color: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
                textAlign: "right",
                p: 0,
              },
            }}
          >
            <IconButton
              onClick={() => dispatch(setIsCartOpen({}))}
              data-testid="cart-button"
              aria-label="Cart"
              sx={{
                color: shades.neutral[700],
                transition: "all 0.3s ease",
                "&:hover": {
                  color: shades.secondary[500],
                  transform: "scale(1.1)",
                  backgroundColor: "rgba(214, 0, 28, 0.1)",
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "24px",
                },
              }}
            >
              <ShoppingBagOutlined />
            </IconButton>
          </Badge>
          <IconButton
            sx={{
              color: shades.neutral[700],
              transition: "all 0.3s ease",
              "&:hover": {
                color: shades.secondary[500],
                transform: "scale(1.1)",
                backgroundColor: "rgba(214, 0, 28, 0.1)",
              },
              "& .MuiSvgIcon-root": {
                fontSize: "24px",
              },
            }}
          >
            <MenuOutlined />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default Navbar;
